import { formatDate } from "../../../../utils/Utils";
import { typeFormatter } from "../../../../utils/tableDataFormatter";
import { HEADER_STYLE, DATA_STYLE } from "../excelReportStyles";
import { formatPlantTrainName, addBordersToSheet } from "../excelReportUtils";

export const createBenchmarkCIPHistorySheet = (sheet, plants, t) => {
  const dateMap = new Map();
  const plantsSet = new Set();

  plants.forEach((plant) => {
    if (plant?.trains && Array.isArray(plant.trains)) {
      plant.trains.forEach((train) => {
        const plantIdentifier = formatPlantTrainName(
          plant.plant_name || plant.name,
          plant.plant_id,
          train.train_num,
        );
        plantsSet.add(plantIdentifier);

        if (train?.historic_cips && Array.isArray(train.historic_cips)) {
          train.historic_cips.forEach((cip) => {
            const dateStr = cip.start_date ? formatDate(cip.start_date) : null;
            if (!dateStr || dateStr === "-") {
              return;
            }

            if (!dateMap.has(dateStr)) {
              dateMap.set(dateStr, {});
            }

            const dateEntry = dateMap.get(dateStr);
            const cipType = typeFormatter({ value: cip.type }, t) || "-";
            dateEntry[plantIdentifier] = dateEntry[plantIdentifier]
              ? `${dateEntry[plantIdentifier]}, ${cipType}`
              : cipType;
          });
        }
      });
    }
  });

  const plantsList = Array.from(plantsSet).sort((a, b) => {
    const aParts = a.match(/\((\d+)\).*Train (\d+)/);
    const bParts = b.match(/\((\d+)\).*Train (\d+)/);

    if (aParts && bParts) {
      const plantIdA = parseInt(aParts[1], 10);
      const plantIdB = parseInt(bParts[1], 10);
      if (plantIdA !== plantIdB) {
        return plantIdA - plantIdB;
      }
      return parseInt(aParts[2], 10) - parseInt(bParts[2], 10);
    }

    return a.localeCompare(b);
  });

  const sortedDates = Array.from(dateMap.keys()).sort(
    (a, b) => new Date(a) - new Date(b),
  );

  const headerRow = sheet.getRow(1);
  headerRow.getCell(1).value = t("benchMark.headers.startDate");
  Object.assign(headerRow.getCell(1), HEADER_STYLE);
  plantsList.forEach((plant, idx) => {
    const cell = headerRow.getCell(idx + 2);
    cell.value = plant;
    Object.assign(cell, HEADER_STYLE);
  });
  headerRow.commit();

  sortedDates.forEach((date, dateIdx) => {
    const row = sheet.getRow(2 + dateIdx);
    row.getCell(1).value = date;
    Object.assign(row.getCell(1), DATA_STYLE);

    const dateEntry = dateMap.get(date);
    plantsList.forEach((plant, plantIdx) => {
      const cell = row.getCell(plantIdx + 2);
      cell.value = dateEntry[plant] || "-";
      Object.assign(cell, DATA_STYLE);
    });

    row.commit();
  });

  sheet.getColumn(1).width = 14;
  plantsList.forEach((_, idx) => {
    sheet.getColumn(idx + 2).width = 22;
  });

  addBordersToSheet(sheet);
};
